import uploadFileNode from "./uploadFileNode";
import httpRequest from "./httpreq";
import { isFunction, isArray, getSystemTime, logStdout, isDefined } from "../shared/utils";
import fileSys from "../fileoprators/fileSystem";
const fs = window.require("fs");
const path = window.require("path");
const request = window.require("request");
const crypto = require("crypto");
const { exec } = window.require("child_process");
import axios from "axios";
function getFilename(cb) {
  crypto.pseudoRandomBytes(16, function (err, raw) {
    cb(err, err ? undefined : raw.toString("hex"));
  });
}
function getMimetype(file) {
  let mimetype = "application/octet-stream";
  if (file.search(".mp4") >= 0) {
    mimetype = "video/mp4";
  } else if (file.search(".jpg") >= 0) {
    mimetype = "image/jpeg";
  } else if (file.search(".png") >= 0) {
    mimetype = "image/png";
  }
  return mimetype;
}
export const uploadFiles = (files, fileInfos, callback, err = null) => {
  if (!isArray(files) || !isArray(fileInfos)) {
    const result = {
      message: "failed"
    };
    if (callback) callback(result);
  } else {
    if (files.length <= 0 || err) {
      const result = {
        message: !isDefined(err) ? "OK" : "failed",
        fileInfos
      };
      console.log("uplaod files error", err);
      logStdout("upload files result", result);
      if (callback) callback(result);
    } else {
      const filePath = files.pop();
      getFilename((err, filename) => {
        if (err) {
          uploadFiles(files, fileInfos, callback, err);
        } else {
          let fileinfo = {
            filename,
            originalname: fileSys.getFileBaseName(filePath),
            mimetype: getMimetype(filePath),
            size: fileSys.getFileSizeSync(filePath),
            savedate: getSystemTime("-", " ", ":"),
            thumbnail: `${filename}_th.jpg`,
            username: window.session && window.session.user.username,
            fieldname: "media[]"
          };
          logStdout("upload file fileinfo", fileinfo);
          fileInfos.push(fileinfo);
          const ffmpeg = fileSys.getUtilPath("ffmpeg");
          const thumbnailPath = fileSys.getUploadPath(fileinfo.thumbnail);
          const uploadFilePath = fileSys.getUploadPath(fileinfo.filename);
          if (fileinfo.mimetype) {
            if (fileinfo.mimetype === "image/jpeg") {
              // var img2thumCmd = `"${ffmpeg}" -i "${filePath}" -y -vf "scale=-1:ih*(4/3),crop='iw:ih'" "${thumbnailPath}"`
              var img2thumCmd = `"${ffmpeg}" -i "${filePath}" -y -vf "scale=320:240" "${thumbnailPath}"`;
              logStdout("upload file-jpeg to thumbnail cmd", img2thumCmd);
              exec(img2thumCmd, (err) => {
                if (err) {
                  uploadFiles(files, fileInfos, callback, err);
                } else {
                  fileSys.copyOneFileByPipe(filePath, uploadFilePath, (err) => {
                    if (err) {
                      uploadFiles(files, fileInfos, callback, err);
                    } else {
                      insertMedifile(fileinfo, (data) => {
                        if (data.message === "OK") {
                          uploadFiles(files, fileInfos, callback, null);
                        } else {
                          uploadFiles(
                            files,
                            fileInfos,
                            callback,
                            new Error("insert medifile error")
                          );
                        }
                      });
                    }
                  });
                }
              });
            } else if (fileinfo.mimetype === "video/mp4") {
              var v2thumCmd = `"${ffmpeg}" -i "${filePath}" -ss 00:00:00 -vframes 1 -r 1 -ac 1 -ab 2 -s 320*240 -f image2 "${thumbnailPath}"`;
              logStdout("upload file-video to thumbnail cmd", v2thumCmd);
              exec(v2thumCmd, (err) => {
                if (err) {
                  uploadFiles(files, fileInfos, callback, err);
                } else {
                  fileSys.copyOneFileByPipe(filePath, uploadFilePath, (err) => {
                    if (err) {
                      uploadFiles(files, fileInfos, callback, err);
                    } else {
                      insertMedifile(fileinfo, (data) => {
                        if (data.message === "OK") {
                          uploadFiles(files, fileInfos, callback, null);
                        } else {
                          uploadFiles(
                            files,
                            fileInfos,
                            callback,
                            new Error("insert medifile error")
                          );
                        }
                      });
                    }
                  });
                }
              });
            } else if (fileinfo.mimetype === "application/octet-stream") {
              fileSys.copyOneFileByPipe(filePath, uploadFilePath, (err) => {
                if (err) {
                  uploadFiles(files, fileInfos, callback, err);
                } else {
                  insertMedifile(fileinfo, (data) => {
                    if (data.message === "OK") {
                      uploadFiles(files, fileInfos, callback, null);
                    } else {
                      uploadFiles(files, fileInfos, callback, new Error("insert medifile error"));
                    }
                  });
                }
              });
            } else {
              uploadFiles(files, fileInfos, callback, null);
            }
          } else {
            uploadFiles(files, fileInfos, callback, null);
          }
        }
      });
    }
  }
};
export const uploadFilesOld = (files, fileInfos, callback) => {
  let result = {
    message: "failed"
  };
  if (!isArray(files)) {
    throw new Error("uploadFiles function: files need to be an array!");
  }
  if (!files || files.length <= 0) {
    if (isFunction(callback)) {
      result = {
        message: "OK",
        fileInfos: fileInfos
      };
      callback(result);
    }
  } else {
    let file = files.pop();
    uploadFileNode(file, window.server, (res) => {
      if (res.message === "OK") {
        result = {
          message: "proc",
          uploadedCnt: fileInfos.length
        };
        fileInfos.push(res.file);
        if (isFunction(callback)) {
          callback(result);
        }
        uploadFiles(files, fileInfos, callback);
      } else {
        if (isFunction(callback)) {
          result = {
            message: "failed",
            uploadedCnt: fileInfos.length
          };
          callback(result);
        }
      }
    });
  }
};
export const uploadFilesLipidLayer = (files, fileInfos) => {
  return new Promise((resolve, reject) => {
    let result = {
      message: "failed"
    };
    if (!isArray(files)) {
      throw new Error("uploadFiles function: files need to be an array!");
    }
    if (!files || files.length <= 0) {
      result = {
        message: "OK",
        fileInfos: fileInfos
      };
      resolve(result);
    } else {
      let file = files.pop();
      uploadFileNode(file, window.server, (res) => {
        if (res.message === "OK") {
          result = {
            message: "proc",
            uploadedCnt: fileInfos.length
          };
          fileInfos.push(res.file);
          // resolve(result)
          if (!files || files.length <= 0) {
            result = {
              message: "OK",
              fileInfos: fileInfos
            };
            resolve(result);
          } else {
            let file = files.pop();
            uploadFileNode(file, window.server, (res) => {
              if (res.message === "OK") {
                fileInfos.push(res.file);
                result = {
                  message: "OK",
                  fileInfos: fileInfos
                };
                resolve(result);
              } else {
                result = {
                  message: "failed",
                  uploadedCnt: fileInfos.length
                };
                resolve(result);
              }
            });
          }
        } else {
          result = {
            message: "failed",
            uploadedCnt: fileInfos.length
          };
          resolve(result);
        }
      });
    }
  });
};
export const downloadFile = (file, dir, jpgname, callback) => {
  const outPath = path.join(dir, jpgname);
  const srcPath = fileSys.getUploadPath(file.filename);
  fileSys.copyOneFileByPipe(srcPath, outPath, (err) => {
    callback(err);
  });
};
export const downloadFileOld = (file, dir, jpgname, callback) => {
  const { serverip, serverport, sslport, serverssl } = window.server || {};
  let tmpjpg = path.join(dir, jpgname);
  fs.unlink(tmpjpg, () => {
    let out = fs.createWriteStream(path.join(dir, jpgname));
    let res = request({
      method: "GET",
      uri:
        serverssl === 1
          ? `https://${serverip}:${sslport}/media/${file.filename}?access_token=${window.token}`
          : `http://${serverip}:${serverport}/media/${file.filename}?access_token=${window.token}`,
      headers: {
        "cache-control": "no-cache",
        "content-type": file.mimetype,
        "x-access-token": window.token
      }
    })
      .pipe(out)
      .on("finish", () => {
        if (callback) callback();
      });
    res.on("error", (err) => {
      if (err) {
        callback(err);
      }
    });
  });
};

export const downloadFileLipidLayer = (file, dir, jpgname) => {
  return new Promise((resolve, reject) => {
    const { serverip, serverport, sslport, serverssl } = window.server || {};
    let tmpjpg = path.join(dir, jpgname);
    fs.unlink(tmpjpg, () => {
      let out = fs.createWriteStream(path.join(dir, jpgname));
      let res = request({
        method: "GET",
        uri:
          serverssl === 1
            ? `https://${serverip}:${sslport}/media/${file.filename}?access_token=${window.token}`
            : `http://${serverip}:${serverport}/media/${file.filename}?access_token=${window.token}`,
        headers: {
          "cache-control": "no-cache",
          "content-type": file.mimetype,
          "x-access-token": window.token
        }
      })
        .pipe(out)
        .on("finish", () => {
          resolve();
        });
      res.on("error", (err) => {
        if (err) {
          resolve(err);
        }
      });
    });
  });
};
export const downloadMedia = (file, dir) => {
  return new Promise((resolve, reject) => {
    fs.unlink(dir, () => {
      fileSys.copyOneFileByPipe(fileSys.getUploadPath(file.filename), dir, (err) => {
        if (err) {
          reject(err);
        } else {
          resolve();
        }
      });
      // const readStream = fs.createReadStream(fileSys.getUploadPath(file.filename))
      // const writeStream = fs.createWriteStream(dir)
      // readStream.pipe(writeStream)
      // writeStream.on('error', (err) => {
      //   reject(err)
      // })
      // writeStream.on('finish', () => {
      //   resolve()
      // })

      // const { serverip, serverport, sslport, serverssl } = (window.server || {})
      //   let res = request({
      //     method: 'GET',
      //     uri: serverssl === 1 ? `https://${serverip}:${sslport}/media/${file.filename}?access_token=${window.token}` : `http://${serverip}:${serverport}/media/${file.filename}?access_token=${window.token}`,
      //     headers: {
      //       'cache-control': 'no-cache',
      //       'content-type': file.mimetype,
      //       'x-access-token': window.token
      //     }
      //   }).pipe(out).on('finish', () => {
      //     fileSys.clearCache(() => {
      //       fileSys.syncDisk()
      //       resolve()
      //     })
      //   })
      //   res.on('error', err => {
      //     if (err) {
      //       resolve(err)
      //     }
      //   })
    });
  });
};

export const getMarking = (filename, callback) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "getMarking",
    body: {
      filename: filename
    },
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      result.marking = data.obj.marking;
    } else {
      result.message = "failed";
    }

    callback(result);
  });
};
export const updateMarking = (filename, marking, callback) => {
  let result = {
    message: "OK"
  };
  let opt = {
    cmd: "updateMarking",
    body: {
      filename: filename,
      marking: marking
    },
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (data.message === "OK") {
      callback(result);
    } else {
      result.message = "failed";
      callback(result);
    }
  });
};
export const insertMedifile = (info, callback) => {
  let opt = {
    cmd: "insertMediInfo",
    body: {
      fileInfo: info
    },
    token: window.token
  };
  httpRequest(opt, (data) => {
    callback(data);
  });
};
export const delMediaFiles = (files, callback) => {
  let result = {
    message: "OK"
  };
  if (!isArray(files)) {
    throw new Error("delMediaFiles function: files need to be an array!");
  }
  if (!files || files.length <= 0) {
    if (isFunction(callback)) {
      callback(result);
    }
  } else {
    let file = files.pop();
    let opt = {
      cmd: "delMediFile",
      body: {
        filename: file.filename
      },
      token: window.token
    };
    httpRequest(opt, (data) => {
      if (data.message === "OK") {
        delMediaFiles(files, callback);
      } else {
        if (isFunction(callback)) {
          result = {
            message: "failed",
            error: data.error
          };
          callback(result);
        }
      }
    });
  }
};

export const reloadMediafiles = (callback) => {
  let opt = {
    cmd: "reloadMediafiles",
    token: window.token
  };
  httpRequest(opt, (data) => {
    if (isFunction(callback)) {
      callback(data);
    }
  });
};

export const insertMediaFile = (fileInfo, token) => {
  return new Promise(async (resolve, reject) => {
    axios
      .post(`http://127.0.0.1:8080/insertMediInfo`, { fileInfo: fileInfo, access_token: token })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.log(err);
        reject("insertMediaFile err");
      });
  });
};



// WEBPACK FOOTER //
// ./src/services/media.js